export default __webpack_public_path__ + "static/media/480_business01-en-web.bdb4256a.png";